import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Vérifier le token au chargement
  useEffect(() => {
    const initAuth = async () => {
      const token = api.getToken();
      const savedUser = localStorage.getItem('electra_user');
      
      if (token && savedUser) {
        try {
          // Vérifier que le token est encore valide
          const userData = await api.getMe();
          setUser(userData);
        } catch (err) {
          // Token invalide ou expiré
          console.log('Session expirée, déconnexion...');
          api.logout();
          localStorage.removeItem('electra_user');
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = async (email, password) => {
    setError(null);
    try {
      const response = await api.login(email, password);
      const userData = response.user;
      setUser(userData);
      localStorage.setItem('electra_user', JSON.stringify(userData));
      return { success: true, user: userData };
    } catch (err) {
      const errorMessage = err.message || 'Erreur de connexion';
      setError(errorMessage);
      return { success: false, error: errorMessage };
    }
  };

  const register = async (userData) => {
    setError(null);
    try {
      const response = await api.register(userData);
      return { success: true, user: response.user, message: response.message };
    } catch (err) {
      const errorMessage = err.message || 'Erreur lors de l\'inscription';
      setError(errorMessage);
      return { success: false, error: errorMessage };
    }
  };

  const logout = () => {
    api.logout();
    setUser(null);
    setError(null);
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      login, 
      logout, 
      register,
      loading, 
      error,
      isAuthenticated: !!user 
    }}>
      {children}
    </AuthContext.Provider>
  );
};
